export interface FilterBarConfig {
  search?: boolean;
  categories?: boolean;
  cityCodes?: boolean;
  cityAvailability?: boolean;
  vertical?: boolean;
  trustStatus?: boolean;
  insuranceVerified?: boolean;
  isActive?: boolean;
}

export interface FilterBarValues {
  search: string;
  categoryIds: string[];
  cityCodes: string[];
  cityAvailability: string[];
  vertical: string;
  trustStatus: string;
  insuranceVerified: string;
  isActive: string;
}

export const EMPTY_FILTER_VALUES: FilterBarValues = {
  search: '',
  categoryIds: [],
  cityCodes: [],
  cityAvailability: [],
  vertical: '',
  trustStatus: '',
  insuranceVerified: '',
  isActive: '',
};

export interface FilterCategoryOption {
  id: string;
  name: string;
  vertical?: string;
}

export interface FilterCityOption {
  code: string;
  label: string;
}

export interface FilterVerticalOption {
  value: string;
  label: string;
}